import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7be5d3f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shipping-details-totals" }
const _hoisted_2 = {
  key: 0,
  class: "shipping-details-totals__results"
}
const _hoisted_3 = { class: "shipping-details-totals__title" }
const _hoisted_4 = {
  key: 2,
  class: "shipping-details-totals__loader"
}

import BaseWordLoading from '@/components/base/BaseWordLoading.vue';
import BaseError from '@/components/base/BaseError.vue';
import CarrierCard from '@/components/CarrierCard.vue';
import { useMyStore } from '@/v2/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShippingDetailsTotalsV2',
  setup(__props) {

const store = useMyStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (
        _unref(store).state.carriersRates.length > 0 &&
        !_unref(store).state.getting &&
        !_unref(store).state.errorMessage
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('shippingDetailsTotals_title')), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.carriersRates, (rate) => {
            return (_openBlock(), _createElementBlock("div", {
              key: rate.name,
              class: "shipping-details-totals__carrier-cards"
            }, [
              _createVNode(CarrierCard, { rate: rate }, null, 8, ["rate"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(store).state.errorMessage && !_unref(store).state.getting)
      ? (_openBlock(), _createBlock(BaseError, {
          key: 1,
          message: _unref(store).state.errorMessage,
          banner: "",
          "show-icon": "",
          class: "shipping-details-totals__error"
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    (_unref(store).state.getting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(BaseWordLoading, { text: "Calculating" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})